import script from "./ProjectsContentShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsContentShowcase.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsContentShowcase.vue?vue&type=style&index=0&id=1878b7bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1878b7bf"]])

export default __exports__